














































































import { Vue, Component } from 'vue-property-decorator';
import { IModelImage, IModelPrice } from "@/components/Globals/types/custom.t";
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import TransferDesignContent from '@/components/molecule.transferDesign.content.vue';
import LoadingSpinner from '@/components/LoadingSpinner'
import CustomTooltip from '@/components/Globals/CustomTooltip.vue';

import transferDesign from '@/mixins/TransferDesign';

@Component({
  components: {
    CustomContainer,
    CustomButton,
    CustomModal,
    ModalHeader,
    CustomText,
    CustomImage,
    TransferDesignContent,
    CustomTooltip,
    LoadingSpinner
  },
  mixins: [transferDesign],
})
export default class TransferDesign extends Vue {

  disabledCta = true as boolean;
  tooltipEnabled = false as boolean;
  showCta = true as boolean;
  showCloseModal = true as boolean;
  isLoadingData = true as boolean;
  step= "choose-style" as string;// the second step is "transfer-style"
  imageUrls = {} as IModelImage;
  prices = {} as IModelPrice;

  showToolTip(block: boolean): void  {
    this.tooltipEnabled = block;
  }

  blockCtaPrimaryButton(block: boolean): void {
    this.disabledCta = block;
    this.showToolTip(block && this.tooltipEnabled);
  }

  showCtaPrimaryButton(show: boolean): void {
    this.showCta = show;
  }

  onShowCloseIcon(show: boolean): void {
    this.showCloseModal = show;
  }
}
